import { Component, OnInit } from '@angular/core';
import { VersionCheckService } from './services/version-check.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public title = 'H&L Cloud Portal';

  constructor(private versionCheckService: VersionCheckService) {}

  public ngOnInit(): void {
    // Start version checking when app initializes
    this.versionCheckService.startVersionCheck();
  }
}
